import React from 'react';
import {
  Content, LoaderWrapper, LoadingScreen, Text,
} from './styles';

const Loader = (props) => {
  return (
    <LoadingScreen>
      <Content>
        <LoaderWrapper>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
        </LoaderWrapper>
        <Text>
          Wait a minute.
          Camera is launching...
        </Text>
      </Content>
    </LoadingScreen>
  );
};

export default Loader;
